// @flow
import type { DailySummary, Sample, SampleList } from "../../lib/OnlineTypes";
import type { CompanyBranch } from "../../lib/Types";
import React from "react";
import Samples from "./Samples";
import DailySummarySearch from "./DailySummarySearch";
import { DefaultPaddedContainer } from "./Theme";
import styled from "styled-components";
import { fetchJson } from "../../lib/Fetching";
import moment from "moment";
import { paramsDate } from "../../lib/DateFormatting";
import DailySummaryTable from "./DailySummaryTable";

type Props = {
  company_id: ?number,
  canFindCompany: ?boolean,
  runSearch: ?boolean,
  clientView: ?boolean,
  laboratory_company_id: ?number,
};

type State = {
  dailySummary: ?DailySummary,
  searchParams: Object,
  sampleList: SampleList,
};

const ReportContainer = styled.div`
  margin-top: 20px;
`;

const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
`;

export default class DailySummaryPage extends React.Component<Props, State> {
  static defaultProps = {
    runSearch: false,
    clientView: true,
  };

  state = {
    dailySummary: null,
    searchParams: {},
    selectedDate: null,
    exceed: false,
    loading: false,
  };

  loadSamplesForDate = (date: Object, exceed: boolean): Promise<Array<Sample>> => {
    const { searchParams } = this.state;
    const { laboratory_company_id } = this.props;
    this.setState({
      sampleList: null,
      selectedDate: date,
      loading: true,
    });
    return fetchJson("/lims_sample_reporting/samples.json", {
      ...searchParams,
      form: {
        ...searchParams.form,
        laboratory_company_id,
        exceed,
        start_date: moment.utc(date).format("YYYY-MM-DD"),
        end_date: moment.utc(date).format("YYYY-MM-DD"),
      },
    }).then((json) =>
      this.setState({
        sampleList: json.sample_list,
        selectedDate: date,
        exceed,
        loading: false,
      })
    );
  };

  setSummary = (dailySummary: DailySummary, searchParams: Object) => {
    this.setState({ dailySummary, searchParams, sampleList: null });
  };

  reloadSamples = () => {
    this.loadSamplesForDate(this.state.selectedDate, this.state.exceed);
  };

  render() {
    const {
      company_id,
      laboratory_company_id,
      canFindCompany,
      runSearch,
      clientView,
    } = this.props;
    const { dailySummary, sampleList, selectedDate, loading } = this.state;
    return (
      <div>
        <Container>
          <DailySummarySearch
            company_id={company_id}
            onLoadSummary={this.setSummary}
            canFindCompany={canFindCompany || false}
            runSearch={runSearch}
            laboratory_company_id={laboratory_company_id}
            clientView={clientView}
          />
          {dailySummary && (
            <DailySummaryTable
              dailySummary={dailySummary}
              loadSamplesForDate={this.loadSamplesForDate}
              selectedDate={selectedDate}
              loading={loading}
            />
          )}
        </Container>
        {sampleList && (
          <div style={{ marginTop: 20 }}>
            <Samples
              key={sampleList.samples.map((s) => s.identifier)}
              sample_list={sampleList}
              company_id={company_id}
              showAttributes={false}
              clientView={clientView}
              reloadData={this.reloadSamples}
            />
          </div>
        )}
      </div>
    );
  }
}
